document.querySelectorAll('.tab-button').forEach(function (button, index) {
        button.addEventListener('click', function () {
            document.querySelectorAll('.tab-button').forEach(function (btn) {
                btn.classList.remove('active');
            });
            document.querySelectorAll('.tab-content').forEach(function (content) {
                content.classList.remove('active');
            });
            button.classList.add('active');
            document.querySelectorAll('.tab-content')[index].classList.add('active');
        });
    });